import { useEffect, useState } from "react";

export type HTMLScriptElementExtended = HTMLScriptElement & {
  isReady?: boolean;
  itFailedError?: ErrorEvent;
  /**
   * @deprecated Please use itFailedError instead.
   */
  itFailed?: boolean;
};

declare global {
  interface Window {
    __FABRIC_REMOTE_ENTRIES__: { [key in string]?: HTMLScriptElementExtended };
  }
}

window.__FABRIC_REMOTE_ENTRIES__ = window.__FABRIC_REMOTE_ENTRIES__ || {};

export const loadModule = (scope: string, module: string) => {
  return async (): Promise<any> => {
    // Initializes the shared scope. Fills it with known provided modules from
    // this build and all remotes
    // @ts-ignore
    await __webpack_init_sharing__("default");

    const container = (window as any)[scope]; // or get the container somewhere else

    // Initialize the container, it may provide shared modules
    // @ts-ignore
    await container.init(__webpack_share_scopes__.default);

    const factory = await (window as any)[scope].get(module);
    const Module = factory();
    return Module;
  };
};

export const useDynamicScript = (
  url: string,
): {
  isReady: boolean;
  itFailedError: ErrorEvent | null;
  /**
   * @deprecated Please use itFailedError instead.
   */
  itFailed: boolean;
} => {
  const [isReady, setReady] = useState(
    Boolean(window.__FABRIC_REMOTE_ENTRIES__[url]?.isReady),
  );
  const [itFailedError, setFailedError] = useState(
    window.__FABRIC_REMOTE_ENTRIES__[url]?.itFailedError ?? null,
  );
  useEffect(() => {
    const element: HTMLScriptElementExtended =
      window.__FABRIC_REMOTE_ENTRIES__[url] || document.createElement("script");
    if (!window.__FABRIC_REMOTE_ENTRIES__[url]) {
      element.src = url;
      element.type = "text/javascript";
      element.async = true;
      window.__FABRIC_REMOTE_ENTRIES__[url] = element;
      document.head.appendChild(element);
    }
    element.addEventListener("load", () => {
      element.isReady = true;
      setReady(true);
    });
    element.addEventListener("error", (error) => {
      element.itFailed = true;
      element.itFailedError = error;
      setFailedError(error);
    });
  }, [url]);
  return {
    isReady,
    itFailedError,
    /**
     * @deprecated Please use itFailedError instead.
     */
    itFailed: Boolean(itFailedError),
  };
};
